





































































































































































































import Vue from 'vue'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import moment from 'moment'
import {
  PROJECT_ASSISTANT_CREATE_PROJECT_DETAIL,
  PROJECT_ASSISTANT_FETCH_DETAIL_START,
  PROJECT_ASSISTANT_FETCH_PRICING, PROJECT_ASSISTANT_FETCH_UNIT_LIST
} from '@/store/action-types'
import {
  CreateProjectDetailResponse,
  GetPricingResponse, GetUnitCodeListResponse,
  IdBezeichnungItem,
  StartDetailAssistantResponse, UnitCode
} from '@/types/service-response'
import ProductSearch from '@/components/project/ProductSearch.vue'
import { ProductSearchResult } from '@/model/project/ProductSearchResult'
import { CreateProjectDetailPayload, GetPricingRequestPayload } from '@/types/payload'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  stepper: number
  scrollHeight: string

  prozessartList: IdBezeichnungItem[]
  artList: IdBezeichnungItem[]
  unitList: UnitCode[]
  steuerList: IdBezeichnungItem[]
  rabattList: IdBezeichnungItem[]
  waehrungenList: IdBezeichnungItem[]
  gridData: any[]

  valid1: boolean
  menu: boolean
  referenceDate: string
  referenceDateFormatted: string
  dateRules: Array<Function>
  rules: Array<Function>
  decimalRules: Array<Function>
  decimalRulesWithNegative: Array<Function>
  prozessart: number | null
  art: number | null
  produktBeschreibung: string
  produkt: ProductSearchResult | null
  showSearchDialog: boolean

  valid2: boolean
  menge: string
  mengeEinheiten: number | null
  beschreibung: string

  valid3: boolean
  preis: string
  waehrung: number | null
  steuer: number | null
  rabatt: number | null
}

export default Vue.extend({
  name: 'CreateProjectDetailAssistant',

  components: {
    ProgressCircular,
    ProductSearch,
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {
    showDialog: Boolean,
    projectId: Number
  },

  data (): ComponentData {
    const decimalRule = (value: string) => {
      const pattern = /^(\d+(?:[\.\,]\d{1,5})?)$/
      return pattern.test(value) || ''
    }

    const decimalRuleWithNegative = (value: string) => {
      const pattern = /^(-?\d+(?:[\.\,]\d{1,5})?)$/
      return pattern.test(value) || ''
    }

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      stepper: 1,
      scrollHeight: '',

      prozessartList: [],
      artList: [],
      unitList: [],
      steuerList: [],
      rabattList: [],
      waehrungenList: [],
      gridData: [],

      valid1: true,
      menu: false,
      referenceDate: '',
      referenceDateFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || 'Falsche Datum.' : true
        },

        (value: string) => {
          return value.length !== 10 ? 'Falsche Datum.' : true
        }
      ],
      rules: [(value: any): boolean | string => !!value || ''],
      decimalRules: [decimalRule],
      decimalRulesWithNegative: [decimalRuleWithNegative],
      prozessart: null,
      art: null,
      produktBeschreibung: '',
      produkt: null,
      showSearchDialog: false,

      valid2: true,
      menge: '0.000',
      mengeEinheiten: null,
      beschreibung: '',

      valid3: true,
      preis: '0.000',
      waehrung: null,
      steuer: null,
      rabatt: null
    }
  },

  watch: {
    referenceDateFormatted (newVal: string): void {
      if(newVal) {
        this.referenceDate = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.referenceDate = ''
      }
    }
  },

  computed: {
    currentUserId (): number | undefined {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isProductDisabled (): boolean {
      return this.art !== 1 && this.art !== 9
    },

    isAmountDisabled (): boolean {
      return this.art !== 1 && this.art !== 2 && this.art !== 9
    },

    isUnitDisabled (): boolean {
      return this.art !== 1 && this.art !== 2 && this.art !== 9
    },

    showStep3 (): boolean {
      return this.art === 1 || this.art === 2 || this.art === 9
    },

    isNextStepDisabled (): boolean {
      if(this.stepper === 1) {
        if(this.valid1) {
          if((this.art === 1 && !this.produkt) || (this.art === 9 && !this.produkt)) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else if(this.stepper === 2) {
        if(this.valid2) {
          if((this.art === 1 && !this.menge && !this.produkt) || (this.art === 2 && !this.menge && !this.mengeEinheiten) || (this.art === 9 && !this.menge && !this.produkt)) {
            return true
          } else if(this.art === 3 || this.art === 4 || this.art === 5) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return true
      }
    },

    isFinishDisabled (): boolean {
      if (this.art === 1 || this.art === 2 ||this.art === 9) {
        if (this.stepper === 3 && this.valid3) {
          return false
        } else {
          return true
        }
      } else {
        if (this.stepper === 2) {
          return false
        } else {
          return true
        }
      }
    }
  },

  methods: {
    onResize (): void {
      this.scrollHeight = `max-height: calc(100vh - 190px)`
    },

    onReferenceDateChange (date: string): void {
      this.referenceDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onFocusReference (): void {
      setTimeout(() => {
        if(!this.menu) {
          this.menu = true
        }
      }, 100)
    },

    onBlurReference (): void {
      setTimeout(() => {
        if(this.menu) {
          this.menu = false
        }
      }, 100)
    },

    onArtChange (): void {
      this.produkt = null
      this.produktBeschreibung = ''
      this.menge = '0.000'
      this.unitList = []
      this.mengeEinheiten = null
      this.beschreibung = ''
      this.preis = '0.000'
      this.waehrung = null
      this.steuer = null
      this.rabatt = null
      //@ts-ignore
      this.$refs['form1'].resetValidation()
      //@ts-ignore
      this.$refs['form2'].resetValidation()
      //@ts-ignore
      this.$refs['form3'].resetValidation()
    },

    onSearchProductClick (): void {
      this.showSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
    },

    onSelectedProduct (data: ProductSearchResult): void {
      this.showSearchDialog = false
      this.produkt = data
      this.produktBeschreibung = this.produkt && this.produkt.produktBezeichnung ? this.produkt.produktBezeichnung : ''
      this.mengeEinheiten = this.produkt && this.produkt.einheit ? this.produkt.einheit : null
      this.beschreibung = this.produkt && this.produkt.produktBeschreibung ? this.produkt.produktBeschreibung : ''
      this.fetchUnitList(this.produkt)
    },

    onMengeChange (): void {
      if(this.menge === '') {
        this.menge = '0.000'
      } else {
        this.menge = parseFloat(this.menge).toFixed(3)
      }
    },

    onPreisChange (): void {
      if(this.preis === '') {
        this.preis = '0.000'
      } else {
        this.preis = parseFloat(this.preis).toFixed(3)
      }
    },

    onBackClick (): void {
      this.stepper = this.stepper - 1
    },

    onForwardClick (): void {
      if(this.stepper === 1) {
        if(this.art === 2) {
          this.fetchUnitList(null)
        } else {
          this.stepper = this.stepper + 1
        }
      } else if(this.stepper === 2) {
        if (this.art === 1 || this.art === 9) {
          this.fetchPrice()
        } else {
          this.stepper = this.stepper + 1
        }
      } else {
        this.stepper = this.stepper + 1
      }
    },

    onFinishClick (): void {
      this.createProjectDetail()
    },

    onCloseDialog (): void {
      this.$emit('onCloseDialog')
    },

    async createProjectDetail (): Promise<void> {
      const payload: CreateProjectDetailPayload = {
        Projekt: this.projectId,

        Produkt: this.produkt ? this.produkt.produkt : null,
        Lagerung: this.produkt ? this.produkt.lagerung  : null,
        Prozessart: this.prozessart!,
        Art: this.art!,
        ReferenzTermin: this.referenceDate,

        Menge: this.menge? parseFloat(this.menge) : parseFloat('0.000'), //double
        MengeEinheiten: this.produkt ? this.produkt.einheit : this.mengeEinheiten,
        Text: this.beschreibung ? this.beschreibung : '',

        Preis: this.preis ? parseFloat(this.preis) : parseFloat('0.000'), //double
        Waehrung: this.waehrung,
        Steuer: this.steuer,
        Rabatt: this.rabatt,
        Sprache: this.selectedLanguageId
      }

      try {
        this.loading = true
        const response: CreateProjectDetailResponse = await this.$store.dispatch(PROJECT_ASSISTANT_CREATE_PROJECT_DETAIL, payload)
        this.loading = false
        if(!response.IsError) {
          this.$emit('createdProjectDetail', response.ProjectDetailID)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchPrice (): Promise<void> {
      const payload: GetPricingRequestPayload = {
        Projekt: this.projectId!,
        Produkt: this.produkt!.produkt!,
        Menge: parseFloat(this.menge!), //double
        Einheit: this.produkt!.einheit!,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId!
      }

      try {
        this.loading = true
        const response: GetPricingResponse = await this.$store.dispatch(PROJECT_ASSISTANT_FETCH_PRICING, payload)
        this.loading = false
        if(!response.IsError) {
          this.preis = response.Preis ? response.Preis.toFixed(3) : '0.000'
          this.waehrung = response.Waehrung
          this.steuer = response.Steuer
          this.rabatt = response.Rabatt

          const foundWhaerung: IdBezeichnungItem | undefined = this.waehrungenList.find((item: IdBezeichnungItem) => item.ID === response.Waehrung)
          const foundRabatt: IdBezeichnungItem | undefined = this.rabattList.find((item: IdBezeichnungItem) => item.ID === response.Rabatt)
          const foundSteuer: IdBezeichnungItem | undefined = this.steuerList.find((item: IdBezeichnungItem) => item.ID === response.Steuer)

          this.gridData = []
          this.gridData.push(
              {
                ID: 1,
                Bezeichnung: this.produkt!.produktBezeichnung,
                Preis: this.preis,
                PE: response.PreisEinheit,
                FW: foundWhaerung ? foundWhaerung.Bezeichnung : null,
                Rab: foundRabatt ? foundRabatt.Bezeichnung : null,
                St: foundSteuer ? foundSteuer.Bezeichnung : null,
                HK: this.produkt!.lagerCode,
                S: false,
                N: false,
              }
          )
          this.stepper = this.stepper + 1
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchUnitList (product: ProductSearchResult | null): Promise<void> {
      const payload: any = {
        productId: product ? product.produkt : 0,
        projectId: this.projectId!,
        lagerung: product ? product.lagerung : 0
      }
      try {
        this.loading = true
        const response: GetUnitCodeListResponse = await this.$store.dispatch(PROJECT_ASSISTANT_FETCH_UNIT_LIST, payload)
        this.loading = false
        if(!response.IsError && response.Data) {
          this.unitList = response.Data
          if(this.art === 2) {
            this.mengeEinheiten = this.unitList && this.unitList[0] ? this.unitList[0].ID : null
            this.stepper = this.stepper + 1
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      try {
        this.loading = true
        const response: StartDetailAssistantResponse = await this.$store.dispatch(PROJECT_ASSISTANT_FETCH_DETAIL_START, this.projectId)
        this.loading = false
        if(!response.IsError) {
          this.prozessartList = response.ProzessArtList
          this.artList = response.Art
          this.steuerList = response.Steuer
          this.rabattList = response.Rabbat
          this.waehrungenList = response.Waehrungen
          this.prozessart = response.Defaults.ProzessArt
          this.art = response.Defaults.Art
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted (): void {
    this.referenceDate = moment().format('YYYY-MM-DD')
    this.referenceDateFormatted = moment().format('DD.MM.YYYY')
    this.fetchData()
  }
})
